import CustomReport from "./CustomReport";

export default CustomReport;